<template>
    <router-link :to="{name: 'newsEntry', params: {newsID: news.id}}" tag="div" class="news-row d-flex justify-center no-padding-top no-padding-bottom">
        <div class="news-title">{{news.title}} <div v-if="unread" class="unread-news-entry"></div> </div>
        <div class="news-date">{{ news.created_at | formatDate }}</div>
    </router-link>
</template>
<style lang="scss">
.news-row{
    min-height: 13vh;
    height: 13vh;
    max-height: 13vh;
    flex-direction: column;
    cursor: pointer;
}
.news-date{
    font: normal normal normal 3vh/4vh 'RobotoRegular' !important;
    color: $font-color !important;
}
.news-title{
    display: flex;
    font: normal normal Bold 3vh/4vh 'RobotoRegular' !important;
    color: $font-color !important;
}
.unread-news-entry {
    margin-left: 10px;
    background-color: #B71717;
    width: calc(min(2vw, 2vh));
    height: calc(min(2vw, 2vh));
    border-radius: 1vw;
}
</style>
<script>
import moment from 'moment';
export default {
    props: {
        news: {
            type: Object,
            required: true,
        },
    },
    filters: {
        formatDate(value) {
            if(value === null) {
                return '';
            }
            return moment(value).locale('de').format('DD.MM.YYYY HH:mm');
        }
    },
    computed: {
        unreadNews() {
            return this.$store.getters['moduleNews/unreadNews'];
        },
        unread() {
            return this.unreadNews.some(unreadNewsEntry => unreadNewsEntry.id === this.news.id);
        }
    }
}
</script>
